import React, { useEffect, useState, useCallback } from 'react';
import homeloan from "../assets/banner/Home Loan.jpg";
import agriloan from "../assets/banner/Agriculture Loan.jpg";
import goldloan from "../assets/banner/Gold Loan.jpg";
import eduloan from "../assets/banner/Education Loan.jpg";
import homeloanMobile from "../assets/banner/Home Loan mobile size.jpg";
import agriloanMobile from "../assets/banner/Agriculture Loan  mobile size.jpg";
import goldloanMobile from "../assets/banner/Gold Loan mobile size.jpg";
import eduloanMobile from "../assets/banner/Education Loan mobile size.jpg";
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
// cSpell: ignore homeloan agriloan goldloan eduloan homeloanMobile agriloanMobile goldloanMobile eduloanMobile
  const banners = [
    {
      id: 1,
      desktopImage: homeloan,
      mobileImage: homeloanMobile,
      title: 'Home Loan',
      description: 'Lets build your dream home together Your home, your happiness.',
      buttonText: 'Apply Now'
    },
    {
      id: 2,
      desktopImage: agriloan,
      mobileImage: agriloanMobile,
      title: 'Agriculture Loan',
      description: 'Strong support for strong farmers from land to harvest.',
      buttonText: 'Apply Now'
    },
    {
      id: 3,
      desktopImage: goldloan,
      mobileImage: goldloanMobile,
      title: 'Gold Loan',
      description: 'Your gold, Your strength, Our support',
      buttonText: 'Apply Now'
    },
    {
      id: 4,
      desktopImage: eduloan,
      mobileImage: eduloanMobile,
      title: 'Education Loan',
      description: 'Every child deserves a chance to shine.',
      buttonText: 'Apply Now'
    }
  ];

  const nextImage = useCallback(() => {
    setIsTransitioning(true);
    setCurrentImage((prev) => 
      prev === banners.length - 1 ? 0 : prev + 1
    );
    setTimeout(() => setIsTransitioning(false), 500);
  }, [banners.length]);

  useEffect(() => {
    const interval = setInterval(nextImage, 5000);
    return () => clearInterval(interval);
  }, [nextImage]);

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setCurrentImage(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  return (
    <section className="w-full relative overflow-hidden z-10 mt-20" id="home">
      {/* Main container with explicit height */}
      <div className="w-full h-[50vh] md:h-[80vh] lg:h-[90vh] relative">
        {/* Desktop and Tablet Version */}
        <div className="hidden md:block w-full h-full">
          {banners.map((banner, index) => (
            <div
              className={`absolute inset-0 w-full h-full transition-transform duration-500 ease-in-out ${
                isTransitioning ? 'opacity-90' : 'opacity-100'
              }`}
              key={banner.id}
              style={{ transform: `translateX(${(index - currentImage) * 100}%)` }}
              aria-hidden={index !== currentImage}
            >
              <img 
                src={banner.desktopImage} 
                className="w-full h-full object-cover" 
                alt={banner.title} 
                loading={index === 0 ? 'eager' : 'lazy'}
              />
              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-black/10 rounded-lg"></div>
              {/* Content container with padding */}
              <div className="absolute inset-0 flex items-center">
                <div className="container mx-auto px-6">
                  <div className="max-w-2xl text-white">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
                      {banner.title}
                    </h1>
                    <p className="text-xl md:text-2xl mb-8 max-w-lg">
                      {banner.description}
                    </p>
                    <Link 
                      to="/contact-us" 
                      className="bg-[#1e4d91] hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-xl text-lg transition duration-300 transform hover:scale-105 inline-block"
                    >
                      {banner.buttonText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Version */}
        <div className="block md:hidden w-full h-full">
          {banners.map((banner, index) => (
            <div
              className={`absolute inset-0 w-full h-full transition-transform duration-500 ease-in-out ${
                isTransitioning ? 'opacity-90' : 'opacity-100'
              }`}
              key={banner.id}
              style={{ transform: `translateX(${(index - currentImage) * 100}%)` }}
              aria-hidden={index !== currentImage}
            >
              <img 
                src={banner.mobileImage} 
                className="w-full h-full object-fill" 
                alt={banner.title} 
                loading={index === 0 ? 'eager' : 'lazy'}
              />
              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/10 rounded-lg"></div>
              {/* Content container with padding */}
              <div className="absolute inset-0 flex items-center">
                <div className="container mx-auto px-6">
                  <div className="max-w-md text-white">
                    <h1 className="text-3xl font-bold mb-3">
                      {banner.title}
                    </h1>
                    <p className="text-lg mb-6">
                      {banner.description}
                    </p>
                    <Link 
                      to="/contact-us" 
                      className="bg-[#1e4d91] hover:bg-blue-600 text-white font-bold py-2.5 px-6 rounded-xl text-base transition duration-300 transform hover:scale-105 inline-block"
                    >
                      {banner.buttonText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots Navigation */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentImage ? 'bg-[#1e4d91] w-8' : 'bg-white/70 w-2'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;